import { MarketAttributes } from './utils';

export const INTERWEST_MARKETS: MarketAttributes[] = [
  {
    name: 'Hanover',
    method: 'portal',
    isIncumbent: true,
    status: 'renewal',
  },
  {
    name: 'Travelers',
    method: 'portal',
    status: 'quoted',
    portalUrl: 'https://foragents.travelers.com/Business',
  },
  {
    name: 'The Hartford',
    method: 'portal',
    status: 'declined',
    portalUrl: 'https://agency.thehartford.com/home',
  },
  {
    name: 'State Comp Ins Fund (CA)',
    method: 'portal',
    status: 'deferred',
    portalUrl: 'https://portal.scif.com',
  },
  {
    name: 'CRC',
    method: 'email',
    status: 'awaiting',
  },
];
